module.exports = __webpack_public_path__ + "521012a6a3f83c1413965f315b6416f3.png";